<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<nz-form-item class="ui-form-checkbox">
  <nz-form-control>
    <label
      nz-checkbox
      [ngModel]="value"
      (ngModelChange)="onValueChange($event)"
      [disabled]="disabled"
    >
      {{ label | localization }}
    </label>
    @if (link !== '') {
      <button class="underline text-[#00BCD4]"
              (click)="linkClicked.emit()">{{ link | localization }}</button>
    }
  </nz-form-control>
</nz-form-item>
